import React from 'react'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  Link
} from '@mui/material'
import { useForm } from 'react-hook-form'
import { useSnackbar } from 'notistack'
import { useImportSalesRecipients } from '../../../api/sales-commission-incentive'
import { getErrorMessage } from '../../../api/utils'
import FileField from '../../../component/shared/component/FileFieldV2'

const RecipientImport = ({ open, setOpen, refetch }) => {
  const { enqueueSnackbar } = useSnackbar()

  const { mutateAsync: importRecipients, isLoading } = useImportSalesRecipients()

  const {
    handleSubmit,
    reset,
    register,
    setValue,
    trigger,
    formState: { errors }
  } = useForm()

  const onClose = () => {
    reset()
    setOpen(false)
  }

  const onSubmit = async (values) => {
    const formData = new FormData()

    if (values.file && values.file[0]) formData.append('file', values.file[0])
    else return enqueueSnackbar('Please select a file', { variant: 'error' })

    try {
      const response = await importRecipients(formData)

      enqueueSnackbar(response.data.message || 'Import successful', { variant: 'success' })

      refetch()

      onClose()
    } catch (e) {
      enqueueSnackbar(getErrorMessage(e), { variant: 'error', style: { whiteSpace: 'pre-line' } })
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Import Recipients</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant='body2' gutterBottom>
                Please upload a CSV or Excel file. Use the template below for the correct format:
              </Typography>
              <Link href='/api/sales-commission-incentive/recipient/template' download>
                Download Recipient Template
              </Link>
            </Grid>
            <Grid item xs={12}>
              <FileField
                inputProps={{
                  ...register('file'),
                  onChange: (e) => {
                    setValue('file', e?.target?.files)
                    trigger('file')
                  },
                  type: 'file',
                  accept: '.csv, .xlsx'
                }}
                error={!!errors.file}
                helperText={errors.file?.message}
                label='Select File'
                required
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={isLoading}>
            CANCEL
          </Button>
          <Button type='submit' variant='contained' color='primary' disabled={isLoading}>
            IMPORT
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default RecipientImport
